import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {
  handleInspectionRequest?: () => void;
  disabled: boolean;
};

export const DropDownButton: React.FC<Props> = ({
  handleInspectionRequest,
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInspectionRequestInside = () => {
    handleClose(); // Close the menu
    handleInspectionRequest();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: 1.5,
          borderColor: 'rgba(0, 105, 112, 1)',
          color: 'rgba(0, 105, 112, 1)',
          fontWeight: 'bold',
          textTransform: 'none',
          height: '40px',
          padding: 0,
          width: '130px',
          opacity: disabled ? 0.3 : 1, // Reduce opacity only when disabled
          pointerEvents: disabled ? 'none' : 'auto', // Prevent interaction but keep styles
        }}>
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            height: '100%',
            width: '100%',
            justifyContent: 'center',
          }}>
          <span style={{ marginRight: 10 }}>Create</span>
          <div
            style={{
              width: '1px',
              backgroundColor: 'rgba(0, 105, 112, 1)',
              height: '100%',
              margin: '0 8px',
            }}
          />
          <ExpandMoreIcon sx={{ fontSize: 32 }} />
        </Stack>
      </Button>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
            minWidth: '180px',
            padding: '4px 0',
          },
        }}>
        <MenuItem
          onClick={handleInspectionRequestInside}
          sx={{
            fontSize: '14px',
            padding: '10px 16px',
            '&:hover': { backgroundColor: '#F5FAFC' },
          }}>
          Inspection Request
        </MenuItem>
        <MenuItem
          disabled
          sx={{
            fontSize: '14px',
            padding: '10px 16px',
            '&:hover': { backgroundColor: '#F5FAFC' },
          }}>
          Field Report
        </MenuItem>
      </Menu>
    </>
  );
};
